import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserProfileResponse } from "reduxStore/dataTypes";

interface UserState {
  user: UserProfileResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  user: null,
  loading: false,
  error: null,
};

const profileSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    profileRequest(state) {
      state.loading = true;
      state.error = null;
    },
    profileSuccess(state, action: PayloadAction<UserProfileResponse>) {
      state.loading = false;
      state.user = action.payload;
    },
    profileFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { profileRequest, profileSuccess, profileFailure } =
  profileSlice.actions;
export default profileSlice.reducer;
